export const EVENT_PALWORLD_GAME_START = "EVENT_PALWORLD_GAME_START";
export const EVENT_PALWORLD_HEARTBEAT = "EVENT_PALWORLD_HEARTBEAT";
